import { render, staticRenderFns } from "./addRoute.vue?vue&type=template&id=139a55bb&scoped=true"
import script from "./addRoute.vue?vue&type=script&lang=js"
export * from "./addRoute.vue?vue&type=script&lang=js"
import style0 from "./addRoute.vue?vue&type=style&index=0&id=139a55bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a55bb",
  null
  
)

export default component.exports